import { render, staticRenderFns } from "./siteVehicles.vue?vue&type=template&id=0128f87d&scoped=true"
import script from "./siteVehicles.vue?vue&type=script&lang=js"
export * from "./siteVehicles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0128f87d",
  null
  
)

export default component.exports